export default "__VITE_ASSET__DoUI_8_E__"